export default `
  <div class="wb-doc-page">
    <div class="doc-main-title">1.总则</div>
    <div class="doc-text doc-pb32">(1).本条款及细则适用及管辖您使用由本公司提供的生物认证服务。</div>
    <div class="doc-text doc-pb32">(2).您透过启动或使用生物认证服务，即表示您接受并同意本条款。若您不接受本条款，则请勿启动或使用生物认证服务。</div>
    <div class="doc-text">(3).生物认证服务是本公司所提供的服务的一部分，它是代替安全编码验证的另一途径，以核实您的身份，达到向本公司发出指示和授权交易。</div>

    <div class="doc-main-title">2.定义和解释</div>
    <div class="doc-text doc-pb32">(1).除非有相反的说明，客户协议书中定义的术语在本条款中具有相同的含义。</div>
    <div class="doc-text doc-pb32">(2).在本条款中，除非上下文另有要求，下列术语应具有以下含义：</div>
    <div class="doc-text doc-pb32">I.“应用程序”：指您可以在任何移动设备下载的名为【“盈宝证券”】（不时更新）的移动应用程序。并通过该等移动应用程序使用本公司的服务；</div>
    <div class="doc-text doc-pb32">II.“生物认证服务”：指本公司根据本条款提供的身份认证功能。它使您能够在通过应用程序向本公司发出指示时以生物认证凭证验证您的身份；</div>
    <div class="doc-text doc-pb32">III.“生物认证凭证”：指在认可移动设备上使用生物识别凭据（包括 ：指纹 码或面部测绘图或其他生物特征）的身份认证功能；</div>
    <div class="doc-text doc-pb32">IV.“客户协议书”：指经不时修订的《客户协议书》、开户表格和任何其他适用于您的帐户的协议或条款及细则；</div>
    <div class="doc-text doc-pb32">V.“认可移动设备”：指内置苹果或安卓的移动设备以及本公司不时指定可使用于生物认证服务的其他电子设备，包括该等移动设备或电子设备运行的操作系统或软件。</div>
    <div class="doc-text doc-pb32">VI.“安全编码”：指您设定的用于发出指示和授权交易的密码；</div>
    <div class="doc-text">(3).在本条款中，单数词含义包括复数词，反之亦然。而单一性别的词包括所有性别。除非另有说明，对条文的提述指本条款及细则中的条文。</div>

    <div class="doc-main-title">3.客户协议书的补充</div>
    <div class="doc-text">本条款及细则乃附加于客户协议书之上，应与客户协议书一起阅读。就生物认证服务而言，如本条款及细则的条文与客户协议书的条文有任何不一致，概以本条款及细则的条文为准。</div>

    <div class="doc-main-title">4.生物认证服务</div>
    <div class="doc-text doc-pb32">(1).若要启动生物认证服务，您必须启动认可移动设备上的生物认证传感器模块，并执行本公司不时指定的步骤以完成注册。注册成功后，您就可以在应用程序中使用生物认证凭证代替安全编码验证身份，并向本公司发出指示。</div>
    <div class="doc-text doc-pb32">(2).在认可移动设备上启动生物认证服务后，您仍然可以选择在应用程序中使用安全编码向本公司发出指示。</div>
    <div class="doc-text doc-pb32">(3).您可以随时以本公司不时指定的步骤取消生物认证服务。该服务被取消后，您仍可以继续在应用程序中使用安全编码向本公司发出指示。</div>
    <div class="doc-text">(4).本公司有权随时指定或更改生物认证服务的范围和功能，而无须事先通知您。</div>

    <div class="doc-main-title">5.您的确认及责任</div>
    <div class="doc-text doc-pb32">(1).您理解并授权本公司为提供生物认证服务之目的，应用程序将通过连接您的认可移动设备上的生物认证传感器模块验证身份。就此目的而言，您同意进行身份认证过程，并同意本公司访问和使用通过生物认证传感器模块获得的信息。本公司不会存储您的生物认证凭证。</div>

    <div class="doc-text doc-pb32">(2).在本条款中，除非上下文另有要求，下列术语应具有以下含义：</div>
    <div class="doc-text doc-pb32">I.是应用程序的有效用户；</div>
    <div class="doc-text doc-pb32">II.使用您的认可移动设备安装应用程序；</div>
    <div class="doc-text doc-pb32">III.在您的认可移动设备上启动生物认证传感器模块，并登记您最少一个生物认证凭证；</div>
    <div class="doc-text doc-pb32">IV.（i）在您所使用的每部新的认可移动设备；以及（ii）重新安装应用程序或删除认可移动设备内的本地数据之后，您须重新启动生物认证服务，并再次同意本条款。</div>

    <div class="doc-text doc-pb32">(3).您完全明白并同意，在认可移动设备上成功注册生物认证服务后：</div>
    <div class="doc-text doc-pb32">I.每次应用程序检测到该设备上使用生物认证凭证发出与交易相关的指示时，您都被视为已经指示本公司执行该交易；</div>
    <div class="doc-text doc-pb32">II.您必须确保认可移动设备只储存您的生物识别凭据。若您存储任何其他人的生物认证凭证或允许任何其他人的生物认证凭证存储在该设备上，您应对所有指示和由此产生的交易负责。所有该等交易将被视为得到您的授权，并将根据客户协议书的条款，包括关于您在欺诈或重大过失情况下进行的未授权交易的责任的条款，对您具有约束力。</div>

    <div class="doc-text doc-pb32">(4).您应采取所有合理的保安措施，防止您的认可移动设备、生物认证凭证和生物认证服务遭未经授权使用或用作欺诈用途。这些预防措施包括（但不限于）:</div>
    <div class="doc-text doc-pb32">I.采取合理的预防措施，妥善保管并防止您的认可移动设备、生物认证凭证和生物认证服务遗失或用作欺诈用途。您应遵守本公司不时提供的有关使用生物认证服务的安全建议；</div>
    <div class="doc-text doc-pb32">II.您不得在移动设备或操作系统供货商支持或保修的配置范围以外，经过修改的移动设备或操作系统上使用应用程序或生物认证服务。该等设备包括软件保护被破解 （jailbroken）或已开放根目录权限（rooted）的设备。软件保护被破解或已开放根目录权限的设备是指在未经移动服务提供商和手机制造商批准而自行解除其所设限制的设备。在软件保护被破解或已开放根目录权限的设备上使用应用程序或生物认证服务，可能会令保安受损，并导致欺诈或未经授权的交易。在软件保护被破解或已开放根目录权限的设备上使用应用程序或生物认证服务，其风险完全由您承担，本公司不会对您因此遭受或招致的任何损失或损害，或任何其他直接或间接后果承担责任；</div>
    <div class="doc-text doc-pb32">III.若您：（i）有双胞胎兄弟姐妹；或（ii）处于青春期（此时您的面部特征可能正处于快速发育阶段），建议您在应用程序中使用安全编码向本公司发出指示；</div>
    <div class="doc-text doc-pb32">IV.避免在认可移动设备上采取任何可能危及在生物认证服务中使用生物认证凭证的安全性的设定，如停止使用任何功能（例如：在面部识别功能中停止使用能够感知用户注视的功能）；</div>
    <div class="doc-text doc-pb32">V.若您知悉或怀疑您的认可移动设备、生物认证凭证或生物认证服务遭未经授权使用，您应在合适可行下尽快拨打本公司的客户服务热线通知本公司。在合适的情况下，本公司可能会要求您更改安全编码或任何密码、重新登记生物认证凭证或停止使用生物认证服务。</div>

    <div class="doc-text doc-pb32">(5).由本公司收到的所有透过您的身份生物认证服务验证发出的指示，均对您具有约束力。您须根据客户协议书的规定对所有该等指示和所有由此产生的交易承担责任。</div>
    <div class="doc-text">(6).若您允许任何第三方使用您的认可移动设备，或未能遵守您在本合约条款下的义务或任何安全措施，以及本公司不时提供的安全信息和/或其他相关文件，您须对所有损失（包括但不限于因任何未经授权交易而产生的损失）承担责任。</div>

    <div class="doc-main-title">6.本公司的责任限制</div>
    <div class="doc-text doc-pb32">(1).生物认证服务以“按现状”和“按现有可予提供”的原则向您提供。本公司不保证生物认证服务在任何时候均可使用，亦不保证生物认证服务可与任何电子设备、软件、系统或本公司不时提供的其他服务兼容。</div>
    <div class="doc-text doc-pb32">(2).您的认可移动设备上的生物认证传感器模块并非由本公司提供。本公司亦不对生物认证传感器技术负责。本公司不作出任何种类的明示或默示保证，包括对质量、准确性或性能、可商售性、特定目的适用性、所有权或不侵权的任何保证。</div>
    <div class="doc-text doc-pb32">(3).就您使用或无法使用生物认证服务而遭受或招致的任何种类的损失、损害或费用而言，除非该等损失、损害或费用完全和直接由本公司或本公司的员工或代理人的重大疏忽或故意失责造成，本公司概不负责。</div>
    <div class="doc-text">(4).在任何情况下，就任何间接的、特别的、附带的、相应的、惩罚性的或惩戒性的损失或损害，本公司概不负责，包括利润损失、业务中断引致的损失，或您的认可移动设备内任何程序或数据的损失。</div>

    <div class="doc-main-title">7.生物认证服务的修改、暂停和终止</div>
    <div class="doc-text">在本公司合理地认为必要或适宜的情况下，本公司有权随时修改、暂停或终止生物认证服务，而无需事先通知您或给予您任何理由。该等情况包括（但不限于）实际或涉嫌违反安全规定。</div>

    <div class="doc-main-title">8.其他事项</div>
    <div class="doc-text">Apple是苹果公司在美国和其他司法管辖区注册的商标。</div>
    <div class="doc-text doc-pb32">Android是谷歌公司的商标。</div>
  </div>
`
